/* The model chip on the Vision status pill. The frame carries the served
 * bundle's directory id (`mv4-fold14-v6-flow`, `mv2-full-fold15-flow`, …);
 * the operator reads the model name, the raw id stays in the title. */
export function modelLabel(version: unknown): string {
  const v = String(version || '');
  const m = /^mv([1-9])[-_]/i.exec(v);
  return m ? `MV-${m[1]}` : (v || '—');
}
